import type { SelectOption } from '@workspace/core-ts/types';
import { VeloIcon, VaeIcon, CargoIcon } from '@/components/icons';

export const VEHICULE_TYPE_OPTIONS: SelectOption[] = [
    {
        label: 'Vélo Classique',
        value: 'VEL',
        icon: VeloIcon,
    },
    {
        label: 'Vélo à Assistance Electrique (VAE)',
        value: 'VAE',
        icon: VaeIcon,
    },
    {
        label: 'Vélo Cargo (classique ou VAE)',
        value: 'VELC',
        icon: CargoIcon,
    },
];

export const MOTIF_AVENANT_OPTIONS: SelectOption[] = [
    { label: 'Changement de vélo', value: '24' },
    { label: 'Changement de garanties', value: '2' },
    { label: 'Mise à jour de déclaration', value: '8' },
];
